import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import tagType from '../../../../core/constants/tagType';

import {
  Column,
  Row,
  ColorField,
  Icon,
  Dropdown,
  DeleteItem,
  DescriptionText,
} from './styles';

const RowTagGroup = (props) => {
  const [showAction, setShowAction] = useState(false);

  const {
    noBorderFirstIndex,
    action,
    handleEdit,
    handleDelete,
    name,
    description,
    color,
    handleRowClick,
    isExpanded,
    id,
    handleMerge,
  } = props;

  const onRowHover = () => { setShowAction(true); };

  const onRowLeave = () => { setShowAction(false); };

  return (
    <Row onMouseEnter={onRowHover} onMouseLeave={onRowLeave} onClick={handleRowClick}>
      <Column noborder={noBorderFirstIndex}>
        <>
          <Icon name={isExpanded ? 'caret down' : 'caret right'} />
          {name}
        </>
      </Column>
      <Column noborder={noBorderFirstIndex} width={5}>
        <DescriptionText>{description}</DescriptionText>
      </Column>
      <Column noborder={noBorderFirstIndex}>
        <ColorField color={color} />
      </Column>

      <Column noborder={noBorderFirstIndex} width={2}>
        {showAction && action
        && (
          <Dropdown
            item
            text="Actions"
          >
            <Dropdown.Menu>
              <Dropdown.Item onClick={handleEdit}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item onClick={handleMerge}>
                Merge
              </Dropdown.Item>
              <Dropdown.Item onClick={() => { handleDelete(id, tagType.TAG_GROUP); }}>
                <DeleteItem>
                  Delete
                </DeleteItem>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Column>

    </Row>
  );
};

RowTagGroup.propTypes = {
  noBorderFirstIndex: bool.isRequired,
  action: bool.isRequired,
  handleEdit: func.isRequired,
  handleDelete: func.isRequired,
  handleMerge: func.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  color: string.isRequired,
  handleRowClick: func,
  isExpanded: bool,
  id: string.isRequired,
};

RowTagGroup.defaultProps = {
  handleRowClick: () => {},
  isExpanded: false,
};

export default RowTagGroup;
